import React from 'react';
import './CashpointsTransactionAmount.less';

export const CashpointsTransactionAmount = ({text}) => {
	return <span className="cashpoints-transaction-amount">{text}</span>
}
